import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/api/auth/me`, { withCredentials: true });
      setUser(data);
    } catch {
      // Check localStorage fallback
      const stored = localStorage.getItem('xlabel_user');
      if (stored) {
        try {
          const parsed = JSON.parse(stored);
          if (parsed.access_token) {
            const { data } = await axios.get(`${API}/api/auth/me`, {
              headers: { Authorization: `Bearer ${parsed.access_token}` },
              withCredentials: true
            });
            setUser({ ...data, access_token: parsed.access_token });
          } else { setUser(false); }
        } catch { setUser(false); localStorage.removeItem('xlabel_user'); }
      } else { setUser(false); }
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/api/auth/login`, { email, password }, { withCredentials: true });
    localStorage.setItem('xlabel_user', JSON.stringify(data));
    setUser(data);
    return data;
  };

  const register = async (formData) => {
    const { data } = await axios.post(`${API}/api/auth/register`, formData, { withCredentials: true });
    localStorage.setItem('xlabel_user', JSON.stringify(data));
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await axios.post(`${API}/api/auth/logout`, {}, { withCredentials: true }); } catch {}
    localStorage.removeItem('xlabel_user');
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export function apiCall(path, options = {}) {
  const stored = localStorage.getItem('xlabel_user');
  let headers = options.headers || {};
  if (stored) {
    try {
      const { access_token } = JSON.parse(stored);
      if (access_token) headers['Authorization'] = `Bearer ${access_token}`;
    } catch {}
  }
  return axios({ url: `${API}${path}`, withCredentials: true, ...options, headers });
}
